import { render, staticRenderFns } from "./PuzzleEditQuestionModal.vue?vue&type=template&id=0da4777b&scoped=true&"
import script from "./PuzzleEditQuestionModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleEditQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleEditQuestionModal.vue?vue&type=style&index=0&id=0da4777b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da4777b",
  null
  
)

export default component.exports